<template>

  <header class="flex flex-col items-center justify-center py-10 lg:h-screen bg-cover bg-center bg-no-repeat"  :style="{ backgroundImage: 'url(' + require(`@/assets/background.jpg`) + ')' }">
    <div class="flex flex-col items-center max-h-full gap-7">
      <img class="w-full object-contain mt-10 md:mt-20 max-h-[40vh] md:max-h-[60vh]" src="@/assets/logo.png" />
      
      <div class="flex flex-col md:flex-row md:gap-4">
        <button @click="scrollToForm" class="px-8 py-2 mt-3 bg-red-800  text-white text-lg font-semibold hover:bg-black rounded" >
          ACREDITARME
        </button>
        <router-link to="/credenciales" class="px-8 py-2 mt-3 bg-red-800  text-white text-lg font-semibold hover:bg-black rounded" >
          YA ME ACREDITÉ
        </router-link>

      </div>

    </div>
  </header>

</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },  
}

</script>